var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeTotalVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1813_109346)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0719 25.7227C36.0534 20.391 31.3661 16.3613 25.7377 16.3613C19.3646 16.3613 14.1982 21.5277 14.1982 27.9008C14.1982 34.2738 19.3646 39.4402 25.7377 39.4402C27.1642 39.4402 28.5304 39.1813 29.7916 38.708C28.5513 37.3481 27.7831 35.5501 27.7464 33.5733H26.8852V34.7206C26.8852 35.103 26.5027 35.4854 26.1203 35.4854H25.7379C25.3555 35.4854 24.973 35.103 24.973 34.7206V33.5733H22.1686C21.7862 33.5733 21.4037 33.1909 21.4037 32.8084V32.426C21.4037 32.0436 21.6587 31.7886 22.0411 31.7886H27.3951C27.5911 31.7886 27.7682 31.7698 27.9265 31.7394C28.0992 30.9508 28.3906 30.2065 28.781 29.5264C28.7072 29.4173 28.6248 29.3216 28.5423 29.2391C28.1599 28.8567 27.7775 28.7292 27.3951 28.7292H23.9532C23.1884 28.7292 22.2961 28.3468 21.6587 27.7094C21.0213 27.1995 20.6389 26.3072 20.6389 25.4149C20.6389 24.5226 21.0213 23.6302 21.6587 23.1203C22.1686 22.483 23.0609 22.1006 23.9532 22.1006H24.8456V21.0808C24.8456 20.6983 25.1005 20.3159 25.4829 20.3159H25.8654C26.2478 20.3159 26.6302 20.6983 26.6302 21.0808V21.9731H28.9248C29.3072 21.9731 29.6896 22.3555 29.6896 22.7379V22.9929C29.6896 23.3753 29.3072 23.7577 28.9248 23.7577H23.9532C23.5708 23.7577 23.1884 24.0127 22.9334 24.2676C22.551 24.65 22.4235 25.0325 22.4235 25.4149C22.4235 25.7973 22.6785 26.1797 22.9334 26.4347C23.1884 26.6896 23.5708 26.9446 23.9532 26.9446H27.3951C28.2874 26.9446 29.1797 27.1995 29.8171 27.9644C29.8436 27.9856 29.8697 28.0075 29.8953 28.03C31.3245 26.5226 33.3461 25.5824 35.5873 25.5824C36.0949 25.5824 36.5912 25.6306 37.0719 25.7227Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8016 33.4247C41.8016 36.8568 39.0194 39.639 35.5873 39.639C32.1553 39.639 29.373 36.8568 29.373 33.4247C29.373 29.9927 32.1553 27.2104 35.5873 27.2104C39.0194 27.2104 41.8016 29.9927 41.8016 33.4247ZM35.6561 29.3401C35.862 29.3401 36.068 29.546 36.068 29.752V30.2325H37.3037C37.5096 30.2325 37.7156 30.4385 37.7156 30.6444V30.7817C37.7156 30.9877 37.5096 31.1936 37.3037 31.1936H34.6264C34.4204 31.1936 34.2145 31.3309 34.0772 31.4682C33.8712 31.6742 33.8026 31.8801 33.8026 32.086C33.8026 32.292 33.9399 32.4979 34.0772 32.6352C34.2145 32.7725 34.4204 32.9098 34.6264 32.9098H36.4799C36.9604 32.9098 37.441 33.0471 37.7842 33.459C38.1275 33.7336 38.3334 34.2142 38.3334 34.6947C38.3334 35.1752 38.1961 35.5871 37.9215 35.9304C37.6469 36.2736 37.1664 36.4796 36.6858 36.4796H36.2053V37.0974C36.2053 37.3034 35.9993 37.5093 35.7934 37.5093H35.5874C35.3815 37.5093 35.1756 37.3034 35.1756 37.0974V36.4796H33.6653C33.4593 36.4796 33.2534 36.2736 33.2534 36.0677V35.8617C33.2534 35.6558 33.3907 35.5185 33.5966 35.5185H36.4799C36.7545 35.5185 36.9604 35.4498 37.0977 35.3812C37.3037 35.1752 37.3723 34.9693 37.3723 34.7634C37.3723 34.4888 37.235 34.2828 37.0977 34.1455C36.8918 33.9396 36.6858 33.8709 36.4799 33.8709H34.6264C34.2145 33.8709 33.7339 33.665 33.3907 33.3217C33.0474 33.0471 32.8415 32.5666 32.8415 32.086C32.8415 31.6055 33.0474 31.125 33.3907 30.8504C33.6653 30.5071 34.1458 30.3012 34.6264 30.3012H35.1069V29.752C35.1069 29.546 35.2442 29.3401 35.4501 29.3401H35.6561Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_109346",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTotalVolume);
export default __webpack_public_path__ + "static/media/Home_Total_Volume.f719909968498981bc9f59464ea8abcb.svg";
export { ForwardRef as ReactComponent };